import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicUtilityFilled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M8.51.7A.74.74 0 007.5.7C5.63 2.5 2.03 5.8 2.03 9.49A6 6 0 008 15.5a6 6 0 005.97-6.02c0-3.7-3.56-6.95-5.46-8.77zM10.5 9l-2.72 3.9c-.14.2-.45.1-.45-.14V10a.25.25 0 00-.25-.25h-1.5s-.08 0-.14-.04a.25.25 0 01-.11-.23c0-.04.01-.09.04-.13l2.85-3.93c.14-.2.45-.1.45.14V8.3a.25.25 0 00.25.25l1.38.06c.2 0 .32.23.2.4z" />
    </svg>
  );
}

SvgBasicUtilityFilled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicUtilityFilled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicUtilityFilled svgRef={ref} {...props} />
));
export default ForwardRef;
